import { render, staticRenderFns } from "./allComponent.vue?vue&type=template&id=d0829a50&"
import script from "./allComponent.vue?vue&type=script&lang=js&"
export * from "./allComponent.vue?vue&type=script&lang=js&"
import style0 from "./allComponent.vue?vue&type=style&index=0&id=d0829a50&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports